export default __webpack_public_path__ + "static/media/Valson Polyester Private Limited.864969f3.jpg";